var UiSizes;
(function (UiSizes) {
    UiSizes[UiSizes["xSmall"] = 16] = "xSmall";
    UiSizes[UiSizes["small"] = 24] = "small";
    UiSizes[UiSizes["medium"] = 32] = "medium";
    UiSizes[UiSizes["large"] = 64] = "large";
    UiSizes[UiSizes["xlarge"] = 96] = "xlarge";
})(UiSizes || (UiSizes = {}));
export default UiSizes;
